if (!customElements.get('mutuki-room-list')) {
  class MutukiRoomList extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.rows = [...this.querySelectorAll('[data-room-item]')];
      this.button = this.querySelector('[data-room-add]');
      this.status = this.querySelector('[data-room-status]');
      this.total = this.querySelector('[data-room-total]');
      if (!this.button || !this.total || !this.rows.length) return;
      this.querySelector('[data-room-controls]').hidden = false;
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: this.dataset.currency || 'USD' });
      this.addEventListener('input', () => this.update(), { signal: this.controller.signal });
      this.addEventListener('change', () => this.update(), { signal: this.controller.signal });
      this.button.addEventListener('click', () => this.add(), { signal: this.controller.signal });
      this.update();
    }

    disconnectedCallback() { this.controller?.abort(); }

    selection() {
      const items = [];
      let valid = true;
      let amount = 0;
      for (const row of this.rows) {
        const select = row.querySelector('[data-room-variant]');
        const option = select.selectedOptions[0];
        const link = row.querySelector('[data-room-link]');
        const url = new URL(link.dataset.productUrl, location.origin);
        url.searchParams.set('variant', select.value);
        link.href = url.toString();
        if (!row.querySelector('[data-room-include]').checked) continue;
        const field = row.querySelector('[data-room-quantity]');
        const quantity = Number(field.value);
        if (!field.checkValidity() || !Number.isInteger(quantity) || option?.dataset.available !== 'true') { valid = false; continue; }
        const price = Number(option.dataset.price);
        if (!Number.isFinite(price)) { valid = false; continue; }
        amount += price * quantity;
        const existing = items.find(item => item.id === select.value);
        if (existing) existing.quantity += quantity;
        else items.push({ id: select.value, quantity });
      }
      return { items, amount, valid };
    }

    update() {
      const { items, amount, valid } = this.selection();
      this.total.textContent = this.money.format(amount / 100);
      this.button.disabled = this.busy || !valid || !items.length;
    }

    async add() {
      if (this.busy) return;
      const { items, valid } = this.selection();
      if (!valid || !items.length) return;
      this.busy = true;
      this.status.textContent = 'Adding your selection…';
      this.update();
      const root = new URL(this.dataset.root || '/', location.origin);
      try {
        const response = await fetch(new URL('cart/add.js', root), {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        const data = await response.json();
        if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : 'This selection could not be added. Check availability on the product pages.');
        location.assign(new URL('cart', root).toString());
      } catch (error) {
        this.status.textContent = error instanceof TypeError || error instanceof SyntaxError ? 'The connection was interrupted. Check your cart before trying again.' : error.message;
        this.busy = false;
        this.update();
      }
    }
  }
  customElements.define('mutuki-room-list', MutukiRoomList);
}
